import axios from "axios";
import React, { useState } from "react";
import { FiUserPlus, FiMail, FiUser, FiKey, FiShield } from "react-icons/fi";

const CreateUser = () => {
	const [formData, setFormData] = useState({
		email: "",
		username: "",
		password: "",
		role: "",
	});
	const [error, setError] = useState("");

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		console.log("User created:", formData);

		try {
			const { data } = await axios.post(
				"https://ecobank.approot.ng/createUser.php",
				{ ...formData }
			);

			console.log(data);

			if (data && data.status === "error") {
				setError(data.message);
			} else {
				alert("User Created Successfully");
				setFormData({
					email: "",
					username: "",
					password: "",
					role: "",
				});
				setError("");
			}
		} catch (error) {
			console.log(error);
			setError("An unexpected error occurred. Please try again.");
		}
	};

	return (
		<div className='w-full max-w-2xl mt-16 bg-white shadow-xl rounded-3xl p-8 mx-auto flex justify-center items-center'>
			<div className='w-full'>
				<div className='flex items-center gap-3 mb-8'>
					<FiUserPlus className='text-3xl text-blue-600' />
					<h2 className='text-2xl font-semibold text-gray-900'>Create User</h2>
				</div>
				<form
					onSubmit={handleSubmit}
					className='space-y-7'
					autoComplete='new-password'
				>
					{/* Email */}
					<div>
						<label
							htmlFor='email'
							className='block mb-2 text-sm font-semibold text-gray-700'
						>
							Email
						</label>
						<div className='relative'>
							<FiMail className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
							<input
								id='email'
								type='email'
								name='email'
								value={formData.email}
								onChange={handleChange}
								required
								className='w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400'
								aria-describedby='emailHelp'
								autoComplete='off'
								placeholder='example@mail.com'
							/>
						</div>
					</div>

					{/* Username */}
					<div>
						<label
							htmlFor='username'
							className='block mb-2 text-sm font-semibold text-gray-700'
						>
							Username
						</label>
						<div className='relative'>
							<FiUser className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
							<input
								id='username'
								type='text'
								name='username'
								value={formData.username}
								onChange={handleChange}
								required
								className='w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400'
								autoComplete='off'
								placeholder='john_doe'
							/>
						</div>
					</div>

					{/* Password */}
					<div>
						<label
							htmlFor='password'
							className='block mb-2 text-sm font-semibold text-gray-700'
						>
							Password
						</label>
						<div className='relative'>
							<FiKey className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
							<input
								id='password'
								type='password'
								name='password'
								value={formData.password}
								onChange={handleChange}
								required
								className='w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400'
								autoComplete='new-password'
								placeholder='••••••••'
							/>
						</div>
					</div>

					{/* Role */}
					<div>
						<label
							htmlFor='role'
							className='block mb-2 text-sm font-semibold text-gray-700'
						>
							Role
						</label>
						<div className='relative'>
							<FiShield className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
							<select
								id='role'
								name='role'
								value={formData.role}
								onChange={handleChange}
								required
								className='w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-400'
								autoComplete='off'
							>
								<option value='' disabled>
									Select role
								</option>
								<option value='user'>User</option>
								<option value='admin'>Admin</option>
							</select>
						</div>
					</div>

					{/* Submit */}
					<button
						type='submit'
						className='w-full bg-red-600 text-white py-3 rounded-xl font-semibold shadow-md hover:bg-red-700 transition duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-red-400'
					>
						Create User
					</button>

					{/* Error */}
					{error && (
						<div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-md mt-3 text-center font-medium'>
							{error}
						</div>
					)}
				</form>
			</div>
		</div>
	);
};

export default CreateUser;
